import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import { useWatch } from "antd/es/form/Form";
import React, { useEffect, useState } from "react";

type Props = {
  validateFileSize: any;
  uploading: any;
  setUploading: any;
  upload_file: any;
  form: any;
  index: any;
  task_id: any;
  //
  type?: any;
};

const UploadButton = (props: Props) => {
  const [file, setFile] = useState<any>(null);
  const [currentChunkIndex, setCurrentChunkIndex] = useState<any>(null);
  const datasetprivate = useWatch("datasetprivate", props.form);
  const chunkSize = 1024 * 1024 * 5;

  useEffect(() => {
    console.log("useEffect", currentChunkIndex);

    const uploadChunk = async (readerEvent: any) => {
      try {
        console.log("in upload chunk", file);
        if (!file) return;
        const data = readerEvent.target.result;
        console.log("data upload:", readerEvent.target.result);

        // Set up the parameters for the request
        const params = new URLSearchParams();
        params.set("title", file.name);
        params.set("currentChunkIndex", currentChunkIndex);
        const value: any = Math.ceil(file.size / chunkSize);
        params.set("totalChunks", value);
        params.set("type", props.type);
        // params.set("type", props.type == "dataset" ? "dataset" : "datasheet");
        params.set("name", file.name);
        params.set("task_id", props.task_id);

        // Set up the headers for the request
        const headers = {
          "Content-Type": "application/octet-stream",
          //   "x-access-token": getToken(),
        };
        const url =
          process.env.REACT_APP_API + `/media/upload2?` + params.toString();
        console.log("url", url);
        // Make the POST request to the server
        await fetch(url, {
          method: "POST",
          headers: headers,
          body: data,
        })
          .then((response) => response.json())
          .then(async (res) => {
            // Check if this is the last chunk
            const isLastChunk =
              currentChunkIndex === Math.ceil(file.size / chunkSize) - 1;
            // If it is, set the final filename and reset the current chunk index
            if (isLastChunk) {
              file.finalFilename = res.finalFilename;
              //   props.setProgressStatus("success");
              setCurrentChunkIndex(null);
            } else {
              // If it's not, increment the current chunk index
              setCurrentChunkIndex(currentChunkIndex + 1);
            }

            await new Promise((resolve) => setTimeout(resolve, 1000));
            if (res.status == "success" || res.status == "Chunk uploaded") {
              if (res.status == "success") {
                console.log("success", res);
                if (props.type != "public") {
                  const datasetprivate =
                    props.form.getFieldValue("datasetprivate") || [];
                  datasetprivate[props.index].link = res.link; // อัปเดตลิงก์ที่อัปโหลดสำเร็จ
                  props.form.setFieldsValue({
                    datasetprivate,
                  });
                } else {
                  const datasetpublic =
                    props.form.getFieldValue("datasetpublic") || [];
                  datasetpublic[props.index].link = res.link; // อัปเดตลิงก์ที่อัปโหลดสำเร็จ
                  props.form.setFieldsValue({
                    datasetpublic,
                  });
                }
                // setFile(null);
                // props.form.resetFields();
              }
            } else {
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } catch (e) {
        console.error("e", e);
      }
    };

    const readAndUploadCurrentChunk = () => {
      try {
        if (!file) return;
        // Calculate the start and end of the current chunk
        const from = currentChunkIndex * chunkSize;
        const to =
          (currentChunkIndex + 1) * chunkSize >= file.size
            ? file.size
            : from + chunkSize;

        // Slice the file to get the current chunk
        const blob = file.slice(from, to);

        const reader = new FileReader();
        // Set the onload function to upload the chunk when it's read
        reader.onload = (e) => uploadChunk(e);
        // Read the blob as a data URL
        reader.readAsDataURL(blob);
      } catch (e) {
        console.error(e);
      }
    };
    // If a chunk index is set, read and upload the current chunk
    if (currentChunkIndex != null) readAndUploadCurrentChunk();
  }, [chunkSize, currentChunkIndex, file]);
  console.log(
    " props.form.getFieldValue()?.[props.index]?.name",
    props.form.getFieldValue("datasetprivate")?.[props.index]?.name,
  );
  return (
    <>
      <Upload
        beforeUpload={(file) => props.validateFileSize(file, 300)}
        maxCount={1}
        showUploadList={false}
        onChange={async (info) => {
          console.log("onChange1");
          if (info.fileList.length > 0) {
            const file = info.fileList[0].originFileObj;
            const fileName = info.fileList[0].name;
            setFile(info.file);
            setCurrentChunkIndex(0);
            console.log("onChange2", info);
            //   try {
            //     props.setUploading((prev: any) => ({
            //       ...prev,
            //       [props.index]: true,
            //     }));
            //     const task_id = props.form.getFieldValue("Codename");
            //     const response = await props.upload_file({
            //       task_id,
            //       type: "public",
            //       name: fileName,
            //       file,
            //     });

            //     if (response.status === "success") {
            //       const datasetpublic =
            //         props.form.getFieldValue("datasetpublic") || [];
            //       datasetpublic[props.index].link = response.link; // อัปเดตลิงก์ที่อัปโหลดสำเร็จ
            //       props.form.setFieldsValue({
            //         datasetpublic,
            //       });
            //       props.setUploading((prev: any) => ({
            //         ...prev,
            //         [props.index]: false,
            //       })); // อัปเดตค่าในฟอร์ม
            //     } else {
            //       console.error("File upload failed:", response);
            //     }
            //   } catch (error) {
            //     console.error("Error uploading file:", error);
            //   }
          }
        }}
      >
        <Button
          style={{
            backgroundColor: "#0E21A0",
            color: "white",
          }}
          disabled={
            datasetprivate?.[props.index]?.name.length == 0 &&
            props.type != "public"
              ? true
              : false
          }
          icon={!props.uploading[props.index] && <UploadOutlined />}
          loading={props.uploading[props.index]}
        >
          {props.uploading[props.index] ? "Uploading..." : ""}
        </Button>
      </Upload>
    </>
  );
};

export default UploadButton;
